module.exports = __webpack_public_path__ + "img/thumbnail_SiberianTiger_m_erythristic.6511fee4.png";